export const tokens = {
    interior: {
        background: {
            default: 'rgba(255, 255, 255, 0.1)',
            active: 'linear-gradient(90deg, #634ff2 0%, #634ff2 70%) padding-box, linear-gradient(240.45deg, rgba(255, 255, 255, 0.4) -46.9%, rgba(255, 255, 255, 0) 26.62%) border-box, linear-gradient(180deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 100%) border-box',
        },
    },
    twitter: {
        fontSize: {
            smaller: 12,
            small: 14,
            medium: 16,
            large: 24,
        },
        fontWeight: {
            default: 500,
            blurDark: 700,
        },
    },
};
